package shared.model.feature.common.data.api

import kotlinx.serialization.Serializable

@Serializable
data class IdApiDto(
    val id: String,
)
